import { Action } from '@ngrx/store';

export const GET_ALL_BOOKINGS = '[Admin] Get All Bookings';
export const GET_ALL_BOOKINGS_SUCCESS = '[Admin] Get All Bookings Success';
export const GET_ALL_BOOKINGS_FAIL = '[Admin] Get All Bookings Fail';

export const BOOKINGS_BY_GROUP_A_SESSION_COUNT =
  '[Admin] Booking By Group A Session Count';
export const BOOKINGS_BY_GROUP_B_SESSION_COUNT =
  '[Admin] Booking By Group B Session Count';

export const BOOKINGS_BY_COUNTRY = '[Admin] Booking By Country';

export const BOOKINGS_BY_GENDER = '[Admin] Booking By Gender';

export class GetAllBookings implements Action {
  readonly type = GET_ALL_BOOKINGS;
}

export class GetAllBookingsSuccess implements Action {
  readonly type = GET_ALL_BOOKINGS_SUCCESS;
  constructor(public payload: any) {}
}

export class GetAllBookingsFail implements Action {
  readonly type = GET_ALL_BOOKINGS_FAIL;
  constructor(public payload: any) {}
}

export class BookingsByGroupASessionCount implements Action {
  readonly type = BOOKINGS_BY_GROUP_A_SESSION_COUNT;
  constructor(public payload: { counts: any }) {}
}

export class BookingsByGroupBSessionCount implements Action {
  readonly type = BOOKINGS_BY_GROUP_B_SESSION_COUNT;
  constructor(public payload: { counts: any }) {}
}

export class BookingsByCountry implements Action {
  readonly type = BOOKINGS_BY_COUNTRY;
  constructor(public payload: { counts: any }) {}
}

export class BookingsByGender implements Action {
  readonly type = BOOKINGS_BY_GENDER;
  constructor(public payload: { counts: any }) {}
}

export type adminActions =
  | BookingsByGroupASessionCount
  | BookingsByGroupBSessionCount
  | GetAllBookings
  | GetAllBookingsSuccess
  | GetAllBookingsFail
  | BookingsByCountry
  | BookingsByGender;



// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/store/actions/admin.action.ts